import { render, staticRenderFns } from "./AdminWorkshopOrdersScreen.vue?vue&type=template&id=71a13b9a&scoped=true&"
import script from "./AdminWorkshopOrdersScreen.vue?vue&type=script&lang=js&"
export * from "./AdminWorkshopOrdersScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkshopOrdersScreen.vue?vue&type=style&index=0&id=71a13b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a13b9a",
  null
  
)

export default component.exports